import { IPaginatedResponse, IResponse } from "../../../model";
import ServiceBase from "../../../servicebase";
import { IRemitente } from "../model/IRemitente";

export default class RemitenteService extends ServiceBase {
  get = (data:{ email?: string, id?: number }) : Promise<IResponse<IRemitente>> => 
    this.GetFetch<IResponse<IRemitente>>('entity/remitente', data);

  find = (data:{ pageIndex?: number, pageSize?: number, sort?: string, idcliente?: number, clienteNombre?: string, nombre?:string, apellido?:string, email?:string, activo?: boolean }) : Promise<IPaginatedResponse<IRemitente>> => 
    this.GetFetch<IPaginatedResponse<IRemitente>>('entity/remitente/find', data);

  upsert = (data?:IRemitente) : Promise<IResponse<IRemitente>> => 
    this.PostFetch<IResponse<IRemitente>>('entity/remitente', data);

  delete = (data:{ id:number, undelete?: boolean}) : Promise<IResponse<unknown>> => 
    this.DeleteFetch<IResponse<unknown>>('entity/remitente', data);  
}
